const Application = {
  ORG: 'SPSPrimeTravels',
  ORG_DISPLAY_NAME: 'SPS Prime Travels (Doing business as Travel Booking Charges)',
  ORG_ADD_LINE1: '605 E 15th St, Big Spring,',
  ORG_ADD_LINE2: 'TX 79720, USA',
  STORAGE_HOST: 'https://storage.googleapis.com',
  PRODUCTION_API_BASE_URL: 'https://myfaresinfo.com/alpha',
  LOCAL_API_BASE_URL: 'http://localhost:8080/alpha',
  STORAGE_URL_STATIC_ASSETS_PATH: 'https://storage.googleapis.com/sfc-static',
  DOMAIN: 'spsprimetravels.com',
  SUPPORT_PHONE: '+1 (866) 886-3611', 
  CONTACT_EMAIL: 'admin@spsprimetravels.com',
  MAP_ADDRESS: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3374.5886261119645!2d-101.46974661331981!3d32.24224134381873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86f923b3030d1b8d%3A0x62e297e9d8e451cc!2s605%20E%2015th%20St%2C%20Big%20Spring%2C%20TX%2079720!5e0!3m2!1sen!2sus!4v1745682812408!5m2!1sen!2sus',
  CALL_NOW_POPUP_HEADING_TEXT: 'Call now for Booking, Changes and Cancellation',
  CALL_NOW_POPUP_SAVE_PRICE: 1200,
  CALL_NOW_POPUP_SAME_PAGE_TIMEOUT_SEC: 1003,
  DISCLAIMER: `SPS Prime Travels (Doing business as Travel Booking Charges), is an independent platform designed to assist users in booking flights, with no affiliations or ties to specific airlines. The airline information provided on our site is for reference purposes only and does not imply any partnerships or endorsements. Our primary focus is helping travelers find budget-friendly flight options, completely free from airline associations.`,
  GA_ID: '',
};
export default Application;
